import React, { Component } from 'react'
import './style.css'
import CalendarBody from './CalendarBody'

export default class Calendar extends Component {

    state = {
        year : '',
        month : ''
    }

    componentDidMount() {

        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth()

        this.setState({
            year : year,
            month : month
        })
    
    }
 

    prevFx = () => {

        let newDate = new Date(this.state.year, this.state.month - 1)

        let year = newDate.getFullYear()
        let month = newDate.getMonth()

        this.setState({
            year : year,
            month: month
        })
    }


    nextFx = () => {

	    let newDate = new Date(this.state.year, this.state.month + 1)
        let year = newDate.getFullYear()
        let month = newDate.getMonth()

        this.setState({
            year : year,
            month: month
        })
    }


    render() {

        const WrapperStyle = {
            position: 'relative',
            height : '100vh'
        }

        const DateTxt = () => {

            const monthEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            
            return (

                <React.Fragment>
                
                    <i className='material-icons' onClick={ this.prevFx }>keyboard_arrow_left</i>
                
                    <span>{ monthEn[this.state.month] } { this.state.year }</span>
                
                    <i className='material-icons' onClick={ this.nextFx }>keyboard_arrow_right</i>
                
                </React.Fragment>
            )
        }


        return(

            <div style={ WrapperStyle }>

                <div id='CalHead'>
                    
                    <DateTxt />
                    
                </div>

                <CalendarBody year={ this.state.year } month={ this.state.month } />

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/calendar/index.js